import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "isLoading", "width"],
  _excluded2 = ["children", "gap"],
  _excluded3 = ["dividerColor", "gap"],
  _excluded4 = ["children", "isVisible", "gap"],
  _excluded5 = ["gap"],
  _excluded6 = ["children", "variant"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button, LayoutDividerVertical, LayoutHorizontal, LayoutSpaceVertical, Modal } from 'breeze-intelligence-kit';
import { BulkUsage } from './BulkUsage';
import { DisclaimerText } from '../DisclaimerText';
import { ModalBulkLoading } from './ModalBulkLoading';
import { MODAL_WIDTH } from '../../constants';
import { EnrichmentActionButton } from '../EnrichmentPropertiesPanel/EnrichmentActionButton';
import { CreditUpgradeTooltip } from './CreditUpgradeTooltip';
import { UsageEstimate } from '../Usage/UsageEstimate';
import { UsageAlert } from '../Usage/UsageAlert';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const ModalBulk = _ref => {
  let {
      children,
      isLoading,
      width = MODAL_WIDTH
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Modal, Object.assign({}, rest, {
    width: width,
    children: isLoading ? /*#__PURE__*/_jsx(ModalBulkLoading, {}) : /*#__PURE__*/_jsx(_Fragment, {
      children: children
    })
  }));
};
ModalBulk.displayName = 'ModalBulk';
function ModalBulkHeader(props) {
  return /*#__PURE__*/_jsx(Modal.Header, Object.assign({}, props));
}
ModalBulkHeader.displayName = 'ModalBulk.Header';
ModalBulk.Header = ModalBulkHeader;
function ModalBulkHeading(props) {
  return /*#__PURE__*/_jsx(Modal.Heading, Object.assign({}, props));
}
ModalBulkHeading.displayName = 'ModalBulk.Heading';
ModalBulk.Heading = ModalBulkHeading;
const Body = _ref2 => {
  let {
      children,
      gap = 'space-md'
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(Modal.Body, {
    children: /*#__PURE__*/_jsx(LayoutSpaceVertical, Object.assign({}, rest, {
      gap: gap,
      children: children
    }))
  });
};
ModalBulk.Body = Body;
const DividerSection = _ref3 => {
  let {
      dividerColor = 'border-light',
      gap = 'space-md'
    } = _ref3,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded3);
  return /*#__PURE__*/_jsx(LayoutDividerVertical, Object.assign({}, rest, {
    dividerColor: dividerColor,
    gap: gap
  }));
};
ModalBulk.DividerSection = DividerSection;
const Footer = _ref4 => {
  let {
      children,
      isVisible = true,
      gap = 'space-sm'
    } = _ref4,
    rest = _objectWithoutPropertiesLoose(_ref4, _excluded4);
  if (!isVisible) {
    return null;
  }
  return /*#__PURE__*/_jsx(Modal.Footer, {
    children: /*#__PURE__*/_jsx(LayoutSpaceVertical, Object.assign({}, rest, {
      gap: gap,
      children: children
    }))
  });
};
ModalBulk.Footer = Footer;
const FooterActions = _ref5 => {
  let {
      gap = 'space'
    } = _ref5,
    rest = _objectWithoutPropertiesLoose(_ref5, _excluded5);
  return /*#__PURE__*/_jsx(LayoutHorizontal, Object.assign({}, rest, {
    gap: gap
  }));
};
ModalBulk.FooterActions = FooterActions;
ModalBulk.UpgradeTooltip = CreditUpgradeTooltip;
ModalBulk.ButtonPrimary = EnrichmentActionButton;
const DefaultCancel = /*#__PURE__*/_jsx(FormattedMessage, {
  message: "bulkModal.cancel"
});
const ButtonCancel = _ref6 => {
  let {
      children = DefaultCancel,
      variant = 'transparent'
    } = _ref6,
    rest = _objectWithoutPropertiesLoose(_ref6, _excluded6);
  return /*#__PURE__*/_jsx(Button, Object.assign({}, rest, {
    variant: variant,
    children: children
  }));
};
ModalBulk.ButtonCancel = ButtonCancel;
const Usage = props => /*#__PURE__*/_jsx(BulkUsage, Object.assign({}, props));
ModalBulk.Usage = Usage;
const UsageDisclaimer = props => /*#__PURE__*/_jsx(DisclaimerText, Object.assign({}, props));
UsageDisclaimer.displayName = 'ModalBulk.UsageDisclaimer';
ModalBulk.UsageDisclaimer = UsageDisclaimer;
const BulkUsageAlert = props => /*#__PURE__*/_jsx(UsageAlert, Object.assign({}, props));
BulkUsageAlert.displayName = 'ModalBulk.UsageAlert';
ModalBulk.UsageAlert = BulkUsageAlert;
const BulkUsageEstimate = props => /*#__PURE__*/_jsx(UsageEstimate, Object.assign({}, props));
BulkUsageEstimate.displayName = 'ModalBulk.UsageEstimate';
ModalBulk.UsageEstimate = BulkUsageEstimate;